import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { APP_CONFIG } from 'config/app.config';
import { SpinnerService } from 'app/core/services/spinner/spinner.service';
import { NotificationType } from 'app/shared/models/notification-type';
import { ErrorHandlerService } from 'app/shared/services/error-handler/error-handler.service';
import { NotificationService } from 'app/shared/services/notification/notification.service';
import { UserService } from 'app/shared/services/user/user.service';
import { EmailShippingLabel } from '../models/email-shipping-label.model';
import { EmailShippingLabelService } from '../services/email-shipping-label.service';

@Component({
    selector: 'upsc-email-shipping-label',
    templateUrl: './email-shipping-label.component.html',
    styleUrls: ['./email-shipping-label.component.scss'],
})
export class EmailShippingLabelComponent implements OnInit {

    public formData: FormData = new FormData();
    public ShipmentId = '668335F2-C1D0-4309-BC79-0003B12D91D5';
    public uploadedFile: string;
    public allowedFileTypes = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'xls'];
    public emailTo: string;
    public isInProgress = false;
    public shouldShowShippingInstruction = false;
    @ViewChild('shipmentLabelForm') shipmentLabelForm: any;

    constructor(private userService: UserService,
                public emailShippingLabel: EmailShippingLabel,
                private notificationService: NotificationService,
                private spinnerService: SpinnerService,
                private errorHandlerService: ErrorHandlerService,
                private emailShippingLabelService: EmailShippingLabelService,
                private translateService: TranslateService,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private selfdialogRef: MatDialogRef<EmailShippingLabelComponent>,
    ) {
        this.getUser();
    }

    public get isFormValid(): boolean {
        return this.emailShippingLabel?.ToEmailAddresses?.length > 0
            && this.emailShippingLabel?.FromEmail !== null
            && this.emailShippingLabel?.FromEmail !== ''
            && this.emailShippingLabel?.PhoneNumber !== null
            && this.emailShippingLabel?.PhoneNumber !== '';
    }

    getUser() {
        this.userService.getUser().subscribe(res => {
            this.emailShippingLabel.FromEmail = res.Email;
            this.emailShippingLabel.PhoneNumber = res.TelNum;
        }, error => {

        });
    }

    uploadFile(event) {
        const fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            const file: File = fileList[0];
            if (this.validateFile(file)) {
                this.formData.append('uploadFile', file, file.name);
                this.uploadedFile = file.name;
            }
        }
    }

    public uploadFiles(files: FileList) {
        if (!files || !files.length) {
            return;
        }

        const file: File = files[0];
        if (!this.validateFile(file)) {
            return;
        }

        this.formData.append('uploadFile', file, file.name);
        this.uploadedFile = file.name;
    }

    removeFile() {
        this.uploadedFile = '';
        this.formData = new FormData();
    }

    uploadAttachment() {
        if (this.validateForm()) {
            this.isInProgress = true;
            // this.spinnerService.show();
            if (this.uploadedFile) { // Only if there is file to upload
                this.emailShippingLabelService.uploadFiles(this.formData).subscribe(
                    (response) => {
                        this.emailShippingLabel.AttachmentUrl = response;
                        this.sendShippingLabel(this.emailShippingLabel);
                    }, (error) => {
                        this.notificationService.notify(
                            this.errorHandlerService.getHttpErrorMessage(error),
                            this.translateService.instant('uploadFailed'),
                            NotificationType.ERROR);
                        this.isInProgress = false;
                        this.spinnerService.hide();
                    });
            } else {
                this.sendShippingLabel(this.emailShippingLabel);
            }
        }
    }

    sendShippingLabel(data: EmailShippingLabel) {
        // this.isInProgress = true;
        this.emailShippingLabelService.dropShipmentLabel(data).subscribe(
            (response) => {
                this.isInProgress = false;
                this.notificationService.notify(this.translateService.instant('dropShipmentEmail.emailLabelSent'), this.translateService.instant('emailSentSuccess'), NotificationType.SUCCESS);
                this.selfdialogRef.close({ result: 'success' });
                this.spinnerService.hide();
            },
            (error) => {
                this.isInProgress = false;
                this.spinnerService.hide();
                this.notificationService.notify(
                    this.errorHandlerService.getHttpErrorMessage(error),
                    this.translateService.instant('failedSendingEmail'),
                    NotificationType.ERROR);
            });
    }

    ngOnInit() {
        this.emailShippingLabel = new EmailShippingLabel();
        this.emailShippingLabel.ShipmentId = this.data.shipmentId;
    }

    fillToEmails() {
        this.emailTo.replace(/,(\s+)?$/, '');  //remove last comma if there is no value after comma
        this.emailShippingLabel.ToEmailAddresses = this.emailTo.split(',');
    }

    validateForm(): boolean {
        for (const key in this.emailShippingLabel) {
            if (key === 'ToEmailAddresses' && this.emailShippingLabel.ToEmailAddresses.length === 0) {
                this.notificationService.notify(this.translateService.instant('dropShipmentEmail.atleast1EmailRequired'), this.translateService.instant('validationFailed'), NotificationType.ERROR);
                return false;
            } else if (key === 'ToEmailAddresses' && this.emailShippingLabel.ToEmailAddresses.length > 0) {
                if (this.emailShippingLabel.ToEmailAddresses.length > 5) {
                    this.notificationService.notify(this.translateService.instant('dropShipmentEmail.maximum5EmailsAllowed'), this.translateService.instant('validationFailed'), NotificationType.ERROR);
                    return false;
                }
                for (const emailIndex in this.emailShippingLabel.ToEmailAddresses) {
                    if (!APP_CONFIG.EMAIL_REGEX.test(this.emailShippingLabel.ToEmailAddresses[emailIndex].trim())) {
                        this.notificationService.notify(this.translateService.instant('dropShipmentEmail.toEmailRequired'), this.translateService.instant('validationFailed'), NotificationType.ERROR);
                        return false;
                    }
                }
            } else if (key !== 'Instructions' && key !== 'AttachmentUrl' && Object.prototype.hasOwnProperty.call(this.emailShippingLabel, key) && this.emailShippingLabel[key].toString() === '') {
                this.notificationService.notify('Enter valid ' + key, this.translateService.instant('validationFailed'), NotificationType.ERROR);
                return false;
            }
        }
        return true;
    }

    validateFile(file: File): boolean {
        const fileExtension = file.name.split('.').pop();
        if (file.size > 5242880) {
            this.notificationService.notify(this.translateService.instant('dropShipmentEmail.maxFileSize'), this.translateService.instant('dropShipmentEmail.fileSizeExceeded'), NotificationType.ERROR);
        } else if (!this.isInArray(this.allowedFileTypes, fileExtension)) {
            this.notificationService.notify(this.translateService.instant('dropShipmentEmail.fileFormatNotAllowed'), this.translateService.instant('invalidFile'), NotificationType.ERROR);
        } else {
            return true;
        }
    }

    isInArray(array, word) {
        return array.indexOf(word.toLowerCase()) > -1;
    }
}
